import { DataFetchingClient } from 'data-fetching-client';
export const client = new DataFetchingClient();